module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-list"
  }, [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/stuList'
      }
    }
  }, [_vm._v("学员管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("学员详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main-box"
  }, [_c('Card', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("重置密码")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.basicInfo,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "学员昵称",
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "学员ID",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "birthday",
      "label": "出生日期",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "性别",
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.sex == 1) ? _c('span', [_vm._v("男")]) : (scope.row.sex == 2) ? _c('span', [_vm._v("女")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "signupDate",
      "label": "报名时间",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), (_vm.zxstatus != 4) ? _c('el-table-column', {
    attrs: {
      "prop": "expireDate",
      "label": "会员有效期",
      "align": "center",
      "width": "180"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "积分",
      "align": "center",
      "width": "140"
    }
  }, [_c('div', {
    staticClass: "btnFlex",
    staticStyle: {
      "min-width": "85px"
    }
  }, [
    [_c('span', {
      staticStyle: {
        "padding-right": "10px"
      }
    }, [_vm._v(_vm._s(_vm.totalScore))]), _vm._v(" "), _c('stuScore', {
      on: {
        "stuScoreResult": _vm.editStuScore
      }
    }, [_vm._v("积分")])]
  ], 2)]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号",
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.filterByPhone(scope.row.phone)
            }
          }
        }, [_vm._v(_vm._s(scope.row.phone))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "weixinId",
      "label": "微信号",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rateTeacher",
      "label": "定级老师",
      "align": "center",
      "width": "100"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('Card', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("班级信息")]), _vm._v(" "), _c('stuAddClass', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "classResult": _vm.classChgHandle1
    }
  }, [_vm._v("关联班级")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.classData,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "班级",
      "align": "center",
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.viewClass(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startTime",
      "label": "班级时间",
      "align": "center",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.beginTime) + " 至\n                  " + _vm._s(scope.row.finishTime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "groupName",
      "label": "班级分组",
      "align": "center",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "progress",
      "label": "课程进度",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.package != undefined) ? _c('div', [_vm._v("\n                  " + _vm._s(scope.row.package.progress) + "\n                ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "joinTime",
      "label": "学员入班时间",
      "align": "center",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isWeek) ? _c('span', [_vm._v("\n                  " + _vm._s(scope.row.joinTime) + "\n                  "), (scope.row.joinTimeOrder == 0) ? _c('span', [_vm._v(" (第1周) ")]) : _vm._e(), _vm._v(" "), (scope.row.joinTimeOrder != 0) ? _c('span', [_vm._v("\n                    (第" + _vm._s(scope.row.joinTimeOrder) + "周)\n                  ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isWeek) ? _c('span', [_vm._v(_vm._s(scope.row.joinTime) + " ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stuStartTime",
      "label": "学员课程时间",
      "align": "center",
      "min-width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.stuStartTime) + "\n\n                  "), (scope.row.stuStartTimeOrder == 0) ? _c('span', [_vm._v("(第1周)")]) : _vm._e(), _vm._v(" "), (scope.row.stuStartTimeOrder != 0) ? _c('span', [_vm._v("\n                    (第" + _vm._s(scope.row.stuStartTimeOrder) + "周)")]) : _vm._e(), _vm._v("\n                  至\n                  " + _vm._s(_vm.checkStuEndTime(
          scope.row.stuEndTime,
          scope.row.finishTime
        )) + "\n                ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "在班状态",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("在营")]) : (scope.row.status == 2) ? _c('el-tag', {
          attrs: {
            "type": "gray"
          }
        }, [_vm._v("转班")]) : (scope.row.status == 5) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("结课")]) : (scope.row.status == 4) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("毕业")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": "",
      "align": "center",
      "width": "210",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "btnFlex",
          staticStyle: {
            "min-width": "85px"
          }
        }, [_c('stuChgTime', {
          staticStyle: {
            "margin-right": "10px"
          },
          attrs: {
            "startTime": scope.row.beginTime,
            "endTime": scope.row.finishTime,
            "stuStartTime": scope.row.stuStartTime,
            "stujoinTime": scope.row.joinTime,
            "stuEndTime": scope.row.stuEndTime,
            "currEditClassId": scope.row.classId,
            "btnDisable": scope.row.status == 4,
            "classCount": scope.row.package.count,
            "progressNum1": scope.row.package.progress,
            "expireDate": scope.row.expireDate,
            "kcTime": scope.row.startTime,
            "signupDate": _vm.signupDate,
            "chgStart": true,
            "joinTime1": true,
            "chgEnd": true
          },
          on: {
            "editClassTime": _vm.editClassTimeConfrim
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('stuAddClass', {
          attrs: {
            "oldClass": scope.row.classId,
            "btnDisable": scope.row.status == 4
          },
          on: {
            "classResult": _vm.classChgHandle
          }
        }, [_vm._v("转班")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "delete"
          },
          on: {
            "click": function($event) {
              return _vm.delStu(scope.row)
            }
          }
        }, [_vm._v("删除\n                  ")])], 1)]
      }
    }])
  })], 1)], 1)], 1)]), _vm._v(" "), _c('Card', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("特色课程信息")]), _vm._v(" "), _c('stuAddExtra', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "5px"
    },
    on: {
      "extraResult": _vm.addExtraHandle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.extraData,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleExtraChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "特色课程ID",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "特色课程名称",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "level",
      "label": "级别",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created_at",
      "label": "添加时间",
      "align": "center",
      "min-width": "240"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "type": "danger",
      "icon": "delete2"
    },
    on: {
      "click": _vm.delExtraForStu
    }
  }, [_vm._v("删除")])], 1)], 1)]), _vm._v(" "), _c('Card', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("学情统计")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true,
      "label-width": "150px",
      "model": _vm.formLearn
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "阅读记录:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": _vm.otherDisable,
      "clearable": "",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "选择日期"
    },
    on: {
      "change": _vm.dateNowChage
    },
    model: {
      value: (_vm.formLearn.dateNow),
      callback: function($$v) {
        _vm.$set(_vm.formLearn, "dateNow", $$v)
      },
      expression: "formLearn.dateNow"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "班级名称:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "disabled": _vm.dateDisable,
      "clearable": ""
    },
    on: {
      "change": _vm.changeClass,
      "clear": _vm.clearUser
    },
    model: {
      value: (_vm.className),
      callback: function($$v) {
        _vm.className = $$v
      },
      expression: "className"
    }
  }, _vm._l((_vm.classData), function(item) {
    return _c('el-option', {
      key: item.classId,
      attrs: {
        "label": item.name,
        "value": item.classId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "周数:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "clearable": "",
      "disabled": _vm.dateDisable
    },
    on: {
      "change": _vm.changeWeek
    },
    model: {
      value: (_vm.formLearn.weekNum),
      callback: function($$v) {
        _vm.$set(_vm.formLearn, "weekNum", $$v)
      },
      expression: "formLearn.weekNum"
    }
  }, _vm._l((_vm.getWeekData), function(item) {
    return _c('el-option', {
      key: item.course_id,
      attrs: {
        "label": ((item.name) + " " + (item.date)),
        "value": item.course_id
      }
    }, [_c('span', [_vm._v(_vm._s(item.name) + " ")]), _c('span', [_vm._v(" " + _vm._s(item.date))])])
  }), 1)], 1), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "readTime"
  }, [_vm._v("\n          阅读时长："), _c('span', [_vm._v(_vm._s(_vm._f("setHis")(_vm.readTime)))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.readList,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bookName",
      "label": "书籍名称",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "courseLevel",
      "label": "级别",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "courseName",
      "label": "课程名称",
      "align": "center",
      "min-width": "240"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "originFinishedCount",
      "label": "原音",
      "align": "center",
      "min-width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.originFinishedCount) + "遍\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "explainFinishedCount",
      "label": "讲解",
      "align": "center",
      "min-width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.explainFinishedCount) + "遍\n              ")]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btnFlex",
    staticStyle: {
      "margin-top": "30px",
      "float": "left"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-document"
    },
    on: {
      "click": _vm.exportoper
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      }
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('Card', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("设备信息")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true,
      "label-width": "150px",
      "model": _vm.forminformation
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "SN:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "clearable": ""
    },
    on: {
      "change": _vm.snChageAgin
    },
    model: {
      value: (_vm.forminformation.sn),
      callback: function($$v) {
        _vm.$set(_vm.forminformation, "sn", $$v)
      },
      expression: "forminformation.sn"
    }
  }, _vm._l((_vm.informationData), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "value": item.clientId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "使用记录:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "clearable": "",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "选择日期"
    },
    on: {
      "change": _vm.dateNowChageAgin
    },
    model: {
      value: (_vm.forminformation.dateNow),
      callback: function($$v) {
        _vm.$set(_vm.forminformation, "dateNow", $$v)
      },
      expression: "forminformation.dateNow"
    }
  })], 1), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('h4', [_vm._v("点读次数:" + _vm._s(_vm.need))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bookName",
      "label": "点读书籍",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "level",
      "label": "级别",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "courseName",
      "label": "课程名称",
      "align": "center",
      "min-width": "240"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal2
    },
    on: {
      "size-change": _vm.handleSizeChange1,
      "current-change": _vm.handleCurrentChange1,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('h4', [_vm._v("跟读记录：" + _vm._s(_vm.needFollow))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.followRead,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bookName",
      "label": "书籍",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "text",
      "label": "跟读文本",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "url",
      "label": "跟读",
      "align": "center",
      "min-width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('audio', {
          staticClass: "aud",
          attrs: {
            "controls": "",
            "src": scope.row.url
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "score",
      "label": "分数",
      "align": "center",
      "min-width": "240"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal1
    },
    on: {
      "size-change": _vm.handleSizeChange2,
      "current-change": _vm.handleCurrentChange2,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      }
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('Card', [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("其他信息")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formStu,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备信息:"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.formStu.sn))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "800px"
    },
    attrs: {
      "rows": 5,
      "type": "textarea",
      "disabled": ""
    },
    model: {
      value: (_vm.formStu.remark),
      callback: function($$v) {
        _vm.$set(_vm.formStu, "remark", $$v)
      },
      expression: "formStu.remark"
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "49%",
      "margin-top": "30px",
      "margin-bottom": "50px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmSubmit
    }
  }, [_vm._v("确定")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-455766c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/stu/detailStu.vue
// module id = 684
// module chunks = 1